'use client';
import { Typography as LegacyTypography } from '@/components/typography';
import { Typography } from '@/components/typography/typography';
import Image from 'next/image';

import { CardBadge } from './CardBadge';
import { Developer } from './developers';
import styles from './developersHero.module.scss';

export interface DeveloperCardProps {
  dev: Developer;
  /** When true the card is a duplicate used for the infinite scroll and should be hidden from assistive technology. */
  ariaHidden?: boolean;
}

export const DeveloperCard = ({ dev, ariaHidden }: DeveloperCardProps) => (
  <article
    className={styles.card}
    aria-hidden={ariaHidden}
  >
    <Image
      className={styles.cardImage}
      src={dev.image}
      alt={`${dev.firstName} ${dev.lastName}`}
      fill
      sizes="(max-width: 1024px) 33vw, 20vw"
    />
    <span className={styles.cardScrim} aria-hidden />
    {dev.badge && <CardBadge badge={dev.badge} />}
    {/*eslint-disable-next-line no-constant-binary-expression */}
    {false /* Disabled for now */ && (
      <div className={styles.cardInfo}>
        <LegacyTypography
          tag="span"
          variant="heading1-sub"
          fontFamily="font-neue-plak"
          color="white"
        >
          <span className={styles.cardNameLine}>{dev.firstName}</span>
          {dev.lastName && (
            <span className={styles.cardNameLine}>{dev.lastName}</span>
          )}
        </LegacyTypography>
        <Typography
          as="span"
          color="white"
          className="text-body-sm lg:text-body-xl text-pretty lg:text-neutral-inverted-600 lg:font-bold"
        >
          {dev.role}
        </Typography>
      </div>
    )}
  </article>
);
